// extracted by mini-css-extract-plugin
module.exports = {"MetricButton":"styles_MetricButton__38sza","info":"styles_info__xCz04","metrics":"styles_metrics__3QDlJ","icon":"styles_icon__eoc3o"};